/*
 * ******************************************************
 * Copyright (C) 1994-2021 Babiel GmbH <info@babiel.com>
 *
 * This file is part of a Babiel development
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted without the express
 * permission of Babiel GmbH
 *
 * Any modification is not permitted without the express
 * permission of Babiel GmbH
 *
 * The file may contain confidential and or privileged materials.
 * Any review, retransmission, dissemination or other use of
 * or taking of any action in reliance upon, this file
 * by persons or entities other than the intended is prohibited.
 * ******************************************************
 */

/* eslint-disable sort-keys, no-console */

export type BreakpointName = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type Breakpoints = {
  [breakpointName in BreakpointName]: number;
};

export class BreakpointService {
  static readonly breakpoints: Breakpoints = {
    xs: 0,
    sm: 320,
    md: 768,
    lg: 992,
    xl: 1440,
  };

  private static get viewportWidth(): number {
    return (window.innerWidth > 0) ? window.innerWidth : screen.width;
  }

  public static mediaBreakpointUp(name: BreakpointName): boolean {
    const min = BreakpointService.getBreakpoint(name);
    const { viewportWidth } = BreakpointService;

    return viewportWidth >= min;
  }

  public static mediaBreakpointDown(name: BreakpointName): boolean {
    const max = BreakpointService.getBreakpoint(name);
    const { viewportWidth } = BreakpointService;

    return viewportWidth < max;
  }

  public static mediaBreakpointBetween(lower: BreakpointName, upper: BreakpointName): boolean {
    const min = BreakpointService.getBreakpoint(lower);
    const max = BreakpointService.getBreakpoint(upper);
    const { viewportWidth } = BreakpointService;

    return viewportWidth >= min && viewportWidth < max;
  }

  public static mediaBreakpointOnly(name: BreakpointName): boolean {
    const min = BreakpointService.getBreakpoint(name);
    const next = BreakpointService.getNextBreakpoint(name);
    const max = BreakpointService.getBreakpoint(next);
    const { viewportWidth } = BreakpointService;

    return viewportWidth >= min && viewportWidth < max;
  }

  private static getNextBreakpoint(name: BreakpointName): BreakpointName {
    const { breakpoints } = BreakpointService;
    const breakpointNames = Object.keys(breakpoints) as BreakpointName[];
    const index = breakpointNames.indexOf(name);

    if (index === -1) {
      console.error(`breakpoint \`${name}\` not found in \`${JSON.stringify(breakpoints)}\``);
    }

    return index < breakpointNames.length + 1 ? breakpointNames[index + 1] : null;
  }

  private static getBreakpoint(name: BreakpointName): number {
    const { breakpoints } = BreakpointService;

    return breakpoints[name];
  }
}
